import React from 'react';

interface PixlieMarkProps {
  size?: number;
  className?: string;
}

/** Inline Pixlie favicon mark — use instead of letter "P". */
export const PixlieMark: React.FC<PixlieMarkProps> = ({ size = 32, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={className}
    aria-hidden
  >
    <circle cx="32" cy="32" r="30" fill="#FFFFFF" />
    <g fill="#111111" transform="translate(8 14) scale(0.352)">
      <rect width="44" height="44" />
      <path d="M88 0a44 44 0 0 1-44 44V0h44Z" />
      <path d="M88 44a44 44 0 0 1 44-44v44H88Z" />
      <path d="M0 88a44 44 0 0 1 44-44v44H0Z" />
      <rect x="44" y="44" width="44" height="44" />
      <rect x="88" y="44" width="44" height="44" />
      <circle cx="130" cy="95" r="6" />
    </g>
  </svg>
);

export default PixlieMark;
